import { render, staticRenderFns } from "./DocumentacaoServicoFunerario.vue?vue&type=template&id=fd18a6f4&scoped=true"
import script from "./DocumentacaoServicoFunerario.vue?vue&type=script&lang=js"
export * from "./DocumentacaoServicoFunerario.vue?vue&type=script&lang=js"
import style0 from "./DocumentacaoServicoFunerario.vue?vue&type=style&index=0&id=fd18a6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd18a6f4",
  null
  
)

export default component.exports